import { API_GET } from "../../config";

export const GetPremiumUser = (page) => {
  return API_GET(`/api/user/get-all?is_premium=1&count=${page}`);

};
